export default {
  methods: {
    download(type) {
      if (type === 'pdf') {
        document.getElementById('btn-download').style.display = 'none';
        document.getElementById('background').style.backgroundColor = '#0399cc';
        window.focus();
        window.print();
        document.getElementById('btn-download').style.display = 'inline-flex';
        document.getElementById('background').style.backgroundColor = 'transparent';
      }
      if (type === 'html') {
        window.open(window.location.href, '_blank');
      }
    },
  },
};
